"use client";
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import styles from './Header.module.scss';
import { usePathname } from 'next/navigation';
import AuthenticatedHeaderMenu from '../AuthenticatedHeaderMenu/AuthenticatedHeaderMenu';
import { useAuth } from '@/app/context/AuthContext';

const Header: React.FC = () => {
    const {checkIsUserAuthenticated, login, logout, checkIsUserApiKeyManager} = useAuth();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isApiKeyManager, setIsApiKeyManager] = useState(false);

    const pathname = usePathname();
    const isActiveLink = (href: string) => pathname === (href);

    useEffect(() => {
        checkIsUserAuthenticated()
            .then(result => {
                setIsAuthenticated(result);
                if (result) {
                    checkIsUserApiKeyManager()
                        .then(result => setIsApiKeyManager(result));
                }
            })
            .catch(() => setIsAuthenticated(false));
    });    

    return (
        <section className="pbedkpyswc pbedkpyswc-xl">
            <div className="czydbcbczh czydbcbczh-lg czydbcbczh-xl czydbcbczh-md">
                <div className="zdbyuevuju zdbyuevuju-md" role="aside">
                    <Link href="/">
                        <img
                            className='content picture picture-default'
                            src="/images/cm-logo.svg"
                            alt="Cyclomedia logo"
                            width="180"
                        />
                    </Link>
                </div>
                <div className="vbvadtutfj vbvadtutfj-md" role="article">
                    <nav className="menu menu-wlu0u inline-block">
                        <div className="menu menu-horizontal">
                            <ul className="nav">
                                <li className={'nav-item'}>
                                    <Link href="/" className={`nav-link ${isActiveLink('/') && 'nav-link-active'}`}>
                                        Overview
                                    </Link>
                                </li>
                                <li className={`nav-item ${styles.navItem}`}>
                                    <span className="nav-link">Our APIs</span>
                                    <div className={`dropdown ${styles.dropdown}`}>
                                        <ul className="nav">
                                            <li className="nav-item">
                                                <Link href="/our-apis/street-smart" className={`nav-link ${isActiveLink('/our-apis/street-smart/') && 'nav-link-active'}`}>
                                                    Street Smart API
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/panorama-rendering-api" className={`nav-link ${isActiveLink('/our-apis/panorama-rendering-api/') && 'nav-link-active'}`}>
                                                    Panorama Rendering API
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/aerial-rendering-api" className={`nav-link ${isActiveLink('/our-apis/aerial-rendering-api/') && 'nav-link-active'}`}>
                                                    Aerial Rendering API
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/aerial-map-service" className={`nav-link ${isActiveLink('/our-apis/aerial-map-service/') && 'nav-link-active'}`}>
                                                    Aerial Map Service
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/street-ortho-service" className={`nav-link ${isActiveLink('/our-apis/street-ortho-service/') && 'nav-link-active'}`}>
                                                    Street Ortho Service
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/recording-locations-service" className={`nav-link ${isActiveLink('/our-apis/recording-locations-service/') && 'nav-link-active'}`}>
                                                    Recording Locations Service
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/coverage-service" className={`nav-link ${isActiveLink('/our-apis/coverage-service/') && 'nav-link-active'}`}>
                                                    Coverage Service
                                                </Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link href="/our-apis/3dnl-arcgis-web-service" className={`nav-link ${isActiveLink('/our-apis/3dnl-arcgis-web-service/') && 'nav-link-active'}`}>
                                                    3DNL ArcGIS Web Service
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <Link href="/integrations" className={`nav-link ${isActiveLink('/integrations/') && 'nav-link-active'}`} >
                                        Integrations
                                    </Link>
                                </li>
                                {isAuthenticated && isAuthenticated &&
                                    <li className='nav-item'>
                                        <Link href="/getting-started/" className={`nav-link ${isActiveLink('/getting-started/') && 'nav-link-active'}`}>
                                            Getting Started
                                        </Link>
                                    </li>
                                }                    
                            </ul>
                        </div>
                    </nav>
                </div>
                <AuthenticatedHeaderMenu isAuthenticated={isAuthenticated} login={login} logout={logout} isApiKeyManager={isApiKeyManager} />
            </div>
        </section>
    );
};

export default Header;